import { Component, Input } from '@angular/core';
import { DnBtnSize } from '../dn-primary-btn/dn-primary-btn.config';
import { elemShow } from '../../constants/animations';
import { DnButtonBaseComponent } from '../base/dn-button-base/dn-button-base.component';

@Component({
  selector: 'dn-custom-btn',
  templateUrl: './dn-custom-btn.component.html',
  styleUrl: './dn-custom-btn.component.scss',
  animations: [elemShow],
  standalone: false,
})
export class DnCustomBtnComponent extends DnButtonBaseComponent {
  @Input() btnWidth: string;
  @Input() btnHeight: string;
  @Input() btnStyle: any;
  @Input() size: DnBtnSize = DnBtnSize.FLEX;
  @Input() loaderSize: DnBtnSize = DnBtnSize.FLEX;

  getStyles(): Record<string, string | null> {
    const styles: Record<string, string | null> = {};

    if (this.backgroundColor) {
      styles['background'] = this.backgroundColor;
    }

    if (this.btnWidth) {
      styles['width'] = this.btnWidth;
    }

    if (this.btnHeight) {
      styles['height'] = this.btnHeight;
    }

    // Merge btnStyle if it exists
    if (this.btnStyle) {
      Object.assign(styles, this.btnStyle);
    }

    return styles;
  }
}
